import React, { useState, useEffect, Fragment } from 'react';
import { PrimaryButton, DefaultButton, IconButton, ActionButton, Persona, PersonaSize, TextField } from '@fluentui/react';
import { useSelector } from 'react-redux';
import ClockinForm from './ClockInForm';

function ClockInModal(props) {
    const [time, setTime] = useState("");
    const [session, setSession] = useState("");
    function showTime() {
        var date = new Date();
        var h = date.getHours(); // 0 - 23
        var m = date.getMinutes(); // 0 - 59
        var s = date.getSeconds(); // 0 - 59
        var session = "AM";

        if (h == 0) {
            h = 12;
        }

        if (h > 12) {
            h = h - 12;
            session = "PM";
        }

        h = (h < 10) ? "0" + h : h;
        m = (m < 10) ? "0" + m : m;
        s = (s < 10) ? "0" + s : s;

        var time = h + ":" + m;
        setTime(time);
        setSession(session);
        setTimeout(showTime, 1000);

    }

    useEffect(() => {
        showTime();
    }, []);

    return (
        <div className="displayflex flexcolumn justifycenter aligncenter prelative" style={{ minWidth: 500 }}>
            <div style={{ position: 'absolute', right: 10, top: 10 }}>
                <IconButton
                    iconProps={{ iconName: 'Cancel' }}
                    ariaLabel="Close popup modal"
                    onClick={props.close}
                />
            </div>
            <div className="displayflex width100 flexcolumn p20 mb20 pb30 aligncenter" style={{ width: 450 }}>
                <ClockinForm
                    user={props.user}
                    close={props.close}
                    data={props.data}
                    shared={true}
                    facilityId={props.facilityId}
                    clientsModule={props.clientsModule}
                    requireJobCode={props.requireJobCode}
                    timecardClientRoles={props.timecardClientRoles}
                />
             </div>
            <div className="displayflex width100 px20 py10 spacebetween " style={{ backgroundColor: '#f3f3f3', borderBottomRightRadius: 4, borderBottomLeftRadius: 4  }}>
                <div className="displayflex aligncenter">
                    <i class="ms-Icon ms-Icon--POISolid" style={{ color: 'rgb(255, 152, 0)' }}></i>
                    <h5 className="head-xs ml5">{props.data.facilityName}</h5>
                </div>
                <div className="displayflex aligncenter" style={{ fontSize: 24, fontWeight: 200 }}>{time}<span style={{ fontSize: 14, marginLeft: 3 }}>{session}</span></div>
            </div>
        </div>
    );
}

export default ClockInModal;
